import "./Home.module.css";
import NavegacionPrincipal from "@/reusable_sections/Header";
import EmpoweringYourStrategicGrowth from "./sections/EmpoweringYourStrategicGrowth";
import TrustedByTeachersEverywhere from "./sections/TrustedByTeachersEverywhere";
import SpecializedServicesGrid from "./sections/SpecializedServicesGrid";
import CompromissoVendr from "./sections/CompromissoVendr";
import VocesDelVecindario from "./sections/VocesDelVecindario";
import BookATable from "./sections/BookATable";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <NavegacionPrincipal />
      <EmpoweringYourStrategicGrowth />
      <SpecializedServicesGrid />
      <TrustedByTeachersEverywhere />
      <CompromissoVendr />
      <VocesDelVecindario />
      <BookATable />
      <Footer />
    </div>;
}